<template>
  <v-app class="text">
    <h1>Leerdoelen</h1>

    <v-container grid-list-md>
      <v-layout row wrap>
        <v-flex md3>
          <v-select
              :items="options.courses"
              label="Vak"
              v-model="filter.course_id"
              clearable
              dense
              solo
          ></v-select>
        </v-flex>
        <v-flex md3>
          <v-select
              :items="options.levels"
              label="Niveau"
              v-model="filter.level"
              dense
              clearable
              solo
          ></v-select>
        </v-flex>
        <v-flex md3>
          <v-select
              :items="options.domains"
              label="Domein"
              v-model="filter.domain_id"
              dense
              clearable
              solo
          ></v-select>
        </v-flex>
        <v-flex md3>
          <v-select
              :items="options.subjects"
              label="Vakinhoud"
              v-model="filter.subject_id"
              dense
              clearable
              solo
          ></v-select>
        </v-flex>

        <v-flex xs12>
          <v-data-table
              :headers="headers"
              :items="results"
              class="elevation-1"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="pagination"
          >
            <template slot="items" slot-scope="props">
              <td class="">
                <strong>{{ props.item.course_label }}</strong>
              </td>
              <td class="">
                <strong>{{ props.item.domain_label }}</strong><br>
                <span class="caption">{{ props.item.subject_label }}</span>
              <td class="">
                {{ props.item.label }}
              </td>
            </template>

          </v-data-table>
        </v-flex>

      </v-layout>
    </v-container grid-list-md>





  </v-app>
</template>

<script>
  export default {
    name: 'goals',
    data: () => {
      return {
        rowsPerPageItems: [ 10, 25, 50, 100, { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 } ],
        pagination: {
          rowsPerPage: 10
        },
        headers: [
          { text: 'Vak', value: 'course_label' },
          { text: 'Domein', value: 'domain_label' },
          { text: 'Leerdoel', value: 'label' },
        ],
        filter: {
          level: null,
          course_id: null,
          domain_id: null,
          subject_id: null,
        },
        meta: {
          count: 0
        },
        options: {
          courses:[],
          levels:[],
          domains:[],
          subjects:[]
        },
        results: []
      };
    },
    created () {
      this.fetchData()
    },
    watch: {
      '$route': 'fetchData',
      'filter': {
        handler(val, oldVal) {
          this.filterData();
        },
        deep: true
      },
    },
    methods: {
      fetchData () {

        axios.get('https://leerdoelen.harry.niolab.nl/backend/api/v1/goal/search',{params:this.filter})
          .then((response) => {
            console.log('new data');
            this.meta = response.data.meta;
            this.options = response.data.options;
            this.results = response.data.results;
            this.validateFilters()
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      validateFilters() {
        let validDomain = false;
        for (var d in this.options.domains) {
          if (this.options.domains[d].value === this.filter.domain_id) {
            validDomain = true;
          }
        }
        if (!validDomain) this.filter.domain_id = null;


        let validSubject = false;
        for (var s in this.options.subjects) {
          if (this.options.subjects[s].value === this.filter.subject_id) {
            validSubject = true;
          }
        }
        if (!validSubject) this.filter.subject_id = null;
      },
      filterData() {
        this.fetchData();
      },
    }
  }
</script>